<template>
  <div id="app">
    <component :is="layout" />
  </div>
  <!-- <v-app>
    <v-main style="background-color: rgb(229, 241, 229);">
      <component :is="layout" />
    </v-main>
  </v-app> -->
</template> 

<script>
import Login from './views/layouts/Login'
import Main from './views/layouts/Main'
import UserLoading from './views/layouts/UserLoading'
import {mapGetters} from 'vuex'
export default {
  name: 'App',
  components: {
    Main, 
    Login, 
    UserLoading
  },
  data: () => ({
    //
    user_loading : true,
  }),
  computed: {
    ...mapGetters(['token', 'user']), 
    layout() {
      if (this.user_loading) {
        return 'UserLoading'
      } else if (this.token == undefined) {
        return 'Login'
      } else {
        return 'Main'
      }
    }
  },
  async mounted() {
    try {
      await this.$store.dispatch('find_token')
    }
    catch(e) {
      console.error(e.message)
    }
    this.user_loading = false
  }
};
</script>

<style>
.v-btn__content > .v-icon {
  margin-right: 8px;
}

.v-btn--icon > .v-btn__content > .v-icon {
  margin-right: 0;
}
</style>